import styled from "styled-components/macro";
import { Button } from "../../../../components";
import { media } from "../../../../utils";

export const ConsultarValoresButton = styled(Button)`
  width: 100%;
`;

export const ValoresAReceberImg = styled.img`
  display: none;
  ${media.md()} {
    display: block;
  }
`;

export const TelefoneDetail = styled.span({
  small: {
    display: "block",
    fontSize: "10px",
    marginBottom: "0",
  },
  [media.lg()]: {
    marginBottom: "0",
    "&:first-of-type": {
      minWidth: "140px",
    },
  },
});
export const TelefoneDetailsIcon = styled.svg({
  marginRight: "12px",
});
export const TelefoneDetailsContent = styled.div(() => ({
  [media.lg()]: {
    display: "flex",
    justifyContent: "space-between",
  },
}));
export const TelefoneDetails = styled.a(({ theme }) => ({
  width: "100%",
  margin: "20px auto",
  display: "flex",
  padding: "8px 16px",
  color: theme.color.brandPrimary.light,
  border: `1px solid ${theme.color.brandPrimary.light}`,
  borderRadius: "8px",
  textDecoration: "none",
  [media.lg()]: {
    margin: "20px 0",
    maxWidth: "421px",
  },
}));

export const ModalCloseButton = styled.button(({ theme }) => ({
  border: "none !important",
  width: "100%",
  [media.lg()]: {
    maxWidth: "160px",
    border: `1px solid ${theme.color.brandPrimary.light} !important`,
  },
}));

export const ModalResultadoBody = styled.div({
  width: "100%",
  maxWidth: "376px",
  paddingTop: "20px",
  [media.lg()]: {
    paddingTop: "calc(114px - 28px)",
    margin: "0px calc(104px - 60px)",
  },
});
